import { render, staticRenderFns } from "./StaffSyncrecord.vue?vue&type=template&id=ff9691d6&"
import script from "./StaffSyncrecord.vue?vue&type=script&lang=ts&"
export * from "./StaffSyncrecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports